const BASE_URL = process.env.CARVANA_APP_BASE_URL;

export type AuthorizedReferrer = {
  breadcrumb?: string;
  match?: string;
  matchFromApp?: boolean;
  name: string;
  pattern?: RegExp;
  url?: string;
};

const authorizedReferrers: AuthorizedReferrer[] = [
  { pattern: /\/vehicle\/[0-9]+\/?$/, name: 'vehicle', breadcrumb: 'Vehicle' },
  { pattern: /\/cars(\S)*/, name: 'search', breadcrumb: 'Search Results' },
  { pattern: /\/acquisition(\S)*/, name: 'purchase', breadcrumb: 'Purchase' },
  { pattern: /\/procurement(\S)*/, name: 'purchase', breadcrumb: 'Purchase' },
  { pattern: /\/purchase(\S)*/, name: 'purchase', breadcrumb: 'Purchase' }
];

const getMatch = (referrer: string): AuthorizedReferrer | null =>
  authorizedReferrers.reduce((acc, { pattern, name, ...options }) => {
    const match = referrer.match(pattern);
    return match ? { name, url: `${BASE_URL}${match[0]}`, ...options } : acc;
  }, null);

const getReferrer = (): AuthorizedReferrer | null => {
  const { referrer } = document;

  if (!referrer.startsWith(BASE_URL)) {
    return null;
  }
  const authorizedReferrer = getMatch(referrer);

  return authorizedReferrer;
};

export { getReferrer };
